
import { Component, Prop, Vue } from 'vue-property-decorator';

type Option<T> = { text: string; value: T };

@Component
export default class CPRadioGroup extends Vue {
  @Prop({ required: false })
  public readonly label?: string;

  @Prop()
  public readonly value!: any;

  @Prop()
  public readonly options!: readonly Option<any>[];

  @Prop({ required: false })
  public readonly prependOption!: string;

  @Prop({ default: false })
  public readonly disabled!: boolean;

  @Prop({ required: false, default: false })
  public readonly testId!: string;

  @Prop() public name!: string;

  public select(option: Option<any>): void {
    this.$emit('input', option.value);
    this.$store.commit('clearFieldError', this.name);
  }
}
